import React from "react";
import { PropTypes } from 'prop-types';

export class DisplayMarketingConsent extends React.Component {

    render() {
        const { emailCheckConsentSrc, smsCheckConsentSrc, handleInputChange } = this.props;
        return (
            <div>
                <p className='subheading'>
                    Marketing Consent Preferences
                </p>

                <div className="marketing-constent--terms pl-0">
                    <p className >humm would love to send you exclusive offers from
                        our partner retailers and keep you up to date with the latest news from us. Please select how you'd like to hear from us below. You can opt-out anytime. For details on how we use your personal information please visit our <a
                            id="marketing-consent--privacy-policy"
                            href="https://www.shophumm.com/uk/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</p>

                    <div className='marketingConsent--button-group'>
                        <div className="app-form-check form-group">
                            <button onChange={handleInputChange} >
                                <img className="checkBox" src={emailCheckConsentSrc} alt="checkbox" name="emailRadio"
                                    value={sessionStorage.getItem('emailConsent') === 'true'} />
                                <label htmlFor="emailRadio" className="radio-label">Email</label>
                            </button>
                            <input type="checkbox" name="emailRadio" id="emailRadio" className="app-form-check-input"
                                checked={sessionStorage.getItem('emailConsent') === 'true'} onChange={handleInputChange} />
                        </div>

                        <div className="app-form-check form-group">
                            <button onChange={handleInputChange} >
                                <img className="checkBox" src={smsCheckConsentSrc} alt="checkbox" name="smsRadio"
                                    value={sessionStorage.getItem('smsConsent') === 'true'} />
                                <label htmlFor="smsRadio" className="radio-label">SMS</label>
                            </button>
                            <input type="checkbox" name="smsRadio" id="smsRadio" className="app-form-check-input"
                                checked={sessionStorage.getItem('smsConsent') === 'true'} onChange={handleInputChange} />
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

DisplayMarketingConsent.propTypes = {
    emailCheckConsentSrc: PropTypes.string,
    smsCheckConsentSrc: PropTypes.string,
    handleInputChange: PropTypes.func
}